import React from 'react';
import './Gallery.css';
import { motion } from 'framer-motion';

const products = [
  {
    id: 1,
    title: "Black Solid Chambray Formal Shirt",
    price: "₹839.00",
    oldPrice: "₹1,199.00",
    img: "https://blacksalt.ascentbw.com/Images/Category/New1.webp"
  },
  {
    id: 2,
    title: "Chocolate Brown Classic Solid Shirt",
    price: "₹979.00",
    oldPrice: "₹1,399.00",
    img: "https://blacksalt.ascentbw.com/Images/Category/New2.webp"
  },
  {
    id: 3,
    title: "Grey Vintage Chambray Plain Shirt",
    price: "₹839.00",
    oldPrice: "₹1,199.00",
    img: "https://blacksalt.ascentbw.com/Images/Category/New3.webp"
  },
  {
    id: 4,
    title: "Dark Brown Classic Slim Fit Solid Trousers",
    price: "₹909.00",
    oldPrice: "₹1,299.00",
    img: "https://blacksalt.ascentbw.com/Images/Category/Tro1.webp"
  },
  {
    id: 5,
    title: "Grey Classic Slim Fit Solid Trousers",
    price: "₹839.00",
    oldPrice: "₹1,199.00",
    img: "https://blacksalt.ascentbw.com/Images/Category/Tro2.webp"
  },
  {
    id: 6,
    title: "Aqua Printed Casual Shirt",
    price: "₹1,119.00",
    oldPrice: "₹1,599.00",
    img: "https://blacksalt.ascentbw.com/Images/Category/Cau1.webp"
  },
  {
    id: 7,
    title: "White Checkered Formal Shirt",
    price: "₹1,049.00",
    oldPrice: "₹1,499.00",
    img: "https://blacksalt.ascentbw.com/Images/Category/For1.webp"
  },
  {
    id: 8,
    title: "Black Printed Cotton Shirt",
    price: "₹1,049.00",
    oldPrice: "₹1,499.00",
    img: "https://blacksalt.ascentbw.com/Images/Category/New4.webp"
  },
  {
    id: 9,
    title: "Pink Checkered Slim Fit Shirt",
    price: "₹979.00",
    oldPrice: "₹1,399.00",
    img: "https://blacksalt.ascentbw.com/Images/Category/New5.webp"
  },
  {
    id: 10,
    title: "Dark Grey Printed Shirt",
    price: "₹1,119.00",
    oldPrice: "₹1,599.00",
    img: "https://blacksalt.ascentbw.com/Images/Category/New6.webp"
  },
  {
    id: 11,
    title: "Light Blue Formal Shirt",
    price: "₹899.00",
    oldPrice: "₹1,299.00",
    img: "https://blacksalt.ascentbw.com/Images/Category/For2.webp"
  },
  {
    id: 12,
    title: "Navy Blue Striped Shirt",
    price: "₹999.00",
    oldPrice: "₹1,499.00",
    img: "https://blacksalt.ascentbw.com/Images/Category/Strip1.webp"
  },
  {
    id: 13,
    title: "White Solid Linen Shirt",
    price: "₹1,299.00",
    oldPrice: "₹1,899.00",
    img: "https://blacksalt.ascentbw.com/Images/Category/For3.webp"
  },
  {
    id: 14,
    title: "Olive Green Casual Shirt",
    price: "₹849.00",
    oldPrice: "₹1,199.00",
    img: "https://blacksalt.ascentbw.com/Images/Category/Cau2.webp"
  },
  {
    id: 15,
    title: "Beige Slim Fit Trousers",
    price: "₹949.00",
    oldPrice: "₹1,399.00",
    img: "https://blacksalt.ascentbw.com/Images/Category/Tro3.webp"
  },
  {
    id: 16,
    title: "Maroon Printed Shirt",
    price: "₹1,099.00",
    oldPrice: "₹1,599.00",
    img: "https://blacksalt.ascentbw.com/Images/Category/Pri1.webp"
  },
  {
    id: 17,
    title: "Sky Blue Striped Shirt",
    price: "₹959.00",
    oldPrice: "₹1,399.00",
    img: "https://blacksalt.ascentbw.com/Images/Category/Strip2.webp"
  },
  {
    id: 18,
    title: "Dark Blue Printed Shirt",
    price: "₹1,149.00",
    oldPrice: "₹1,699.00",
    img: "https://blacksalt.ascentbw.com/Images/Category/Pri2.webp"
  },
  {
    id: 19,
    title: "Classic White T-Shirt",
    price: "₹599.00",
    oldPrice: "₹899.00",
    img: "https://blacksalt.ascentbw.com/Images/Category/Cau3.webp"
  },
  {
    id: 20,
    title: "Grey Striped Formal Shirt",
    price: "₹999.00",
    oldPrice: "₹1,499.00",
    img: "https://blacksalt.ascentbw.com/Images/Category/Strip3.webp"
  }
];

const Gallery = () => {
  return (
    <section className="gallery-section" id="gallery">
      <div className="gallery-container">
        <div className="section-header">
          <motion.div 
            className="section-label"
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            OUR GALLERY
          </motion.div>
          <motion.h2 
            className="section-title"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            LATEST COLLECTIONS
          </motion.h2>
        </div>

        <div className="product-grid">
          {products.map((product, index) => (
            <motion.div 
              key={product.id}
              className="product-card"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: (index % 5) * 0.1 }}
            >
              <div className="product-img-box">
                <img src={product.img} alt={product.title} />
              </div>
              <div className="product-info">
                <h3 className="product-name">{product.title}</h3>
                <div className="product-pricing">
                  <span className="current-price">{product.price}</span>
                  <span className="original-price">{product.oldPrice}</span>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
